import React from "react";

const CardComponent = ({ cardDetails, selected, setselected }) => {
  return (
    <div
      className={`cardcomponent ${
        selected === cardDetails?.token && "cardcomponentselected"
      }`}
      style={{ opacity: cardDetails?.expired ? 0.7 : 1 }}
    >
      <div className="d-flex align-items-center">
        <input
          type="radio"
          id={cardDetails?.token}
          value={cardDetails?.token}
          checked={selected === cardDetails?.token}
          onChange={() => setselected(cardDetails?.token)}
          disabled={cardDetails?.expired}
        />
        <div className="text-left ml-2">
          <h6 className="mb-0">{cardDetails?.issuing_bank} Bank Card</h6>
          {cardDetails?.expired ? (
            <h6>Expired</h6>
          ) : (
            <h6>
              {cardDetails?.expiration_month}/{cardDetails?.expiration_year}
            </h6>
          )}
        </div>
      </div>
      <div className="">
        <div className="d-flex align-items-center">
          <img src={cardDetails?.image_url} alt="Card" />
          {cardDetails?.bin && (
            <>
              <h6 className="mb-0 mr-1">{cardDetails?.bin.substring(0, 4)}</h6>
              <h6 className="mb-0">{cardDetails?.bin.substring(4, 6)}</h6>
            </>
          )}
          <h6 className="mb-0 mr-1" style={{ height: "14px" }}>
            {cardDetails?.bin ? "** ****" : "**** **** ****"}
          </h6>
          <h6 className="mb-0">{cardDetails?.last_4}</h6>
        </div>
      </div>
    </div>
  );
};

export default CardComponent;
